// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de0deab5","455":"e295aa11","977":"7257ad2b"}[chunkId] + ".chunk.js";
};